var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Logging, PropertyConverters, Debounce, Utils, P, PCSS, CustomElement, Watch, Defaults, ViewChild } from '@pacem/pacem-core';
import { PacemBaseElement } from './types-components';
//namespace Pacem.Components.Scaffolding {
const emptyVal = '';
const JsonOrStringConverter = {
    convert: (attr, el) => {
        return /\{.+\}/.test(attr) ? PropertyConverters.Json.convert(attr) : PropertyConverters.String.convert(attr);
    },
    convertBack: (prop, el) => {
        if (typeof prop === 'string') {
            return prop;
        }
        return PropertyConverters.Json.convertBack(prop, el);
    }
};
//class DatetimeChangeEvent extends CustomTypedEvent<{ date: Date }> {
//    constructor(date: Date) {
//        super('datetimechange', { date: date });
//    }
//}
let PacemDatetimePickerElement = class PacemDatetimePickerElement extends PacemBaseElement {
    constructor() {
        super();
        this.precision = 'day';
        this._months = [];
        this._dates = [];
        this._a24 = [];
        this._a60 = [];
        this._years = [];
        this.hours = '00';
        this.minutes = '00';
        this.seconds = '00';
    }
    get inputFields() {
        return [this._yearel, this._monthel, this._dateel, this._hourel, this._minel, this._secel];
    }
    toggleReadonlyView(readonly) {
        this._allFields.hidden = readonly;
    }
    convertValueAttributeToProperty(attr) {
        return PropertyConverters.Datetime.convert(attr);
    }
    connectedCallback() {
        super.connectedCallback();
        const today = new Date();
        let year = this.year = today.getFullYear();
        this.min = new Date(year - 100, 0, 1);
        this.max = new Date(year + 10, 11, 31);
        this.month = today.getMonth();
        //
        let months = [], hours = [], minutes = [], leftPad = Utils.leftPad;
        // months
        for (let i = 0; i < 12; i++) {
            let date = new Date(year, i, 1), label = date.toLocaleString(Utils.lang(this), { month: "short" });
            ;
            months.push({ value: i, date: date, label: label });
        }
        this._months = months;
        // hours
        for (let i = 0; i < 24; i++) {
            hours.push(leftPad(i, 2, '0'));
        }
        this._a24 = hours;
        // minutes/secs
        for (let i = 0; i < 60; i++) {
            minutes.push(leftPad(i, 2, '0'));
        }
        this._a60 = minutes;
    }
    propertyChangedCallback(name, old, val, first) {
        super.propertyChangedCallback(name, old, val, first);
        switch (name) {
            case 'dateValue':
                this.log(Logging.LogLevel.Log, `dateValue changed from ${old} to ${val}`);
                this._disassembleDate(val);
                // this.changeHandler(new DatetimeChangeEvent(val));
                break;
            case 'min':
            case 'max':
                if (!Utils.isNullOrEmpty(this.min)
                    && !Utils.isNullOrEmpty(this.max)) {
                    this._setupYears();
                }
                break;
            case 'year':
            case 'month':
                this._buildupDates();
                break;
            case 'date':
            case 'hours':
            case 'minutes':
            case 'seconds':
                this._buildup();
                break;
        }
    }
    acceptValue(val) {
        this.dateValue = Utils.parseDate(val);
    }
    _disassembleDate(v) {
        if (!v) {
            this.date = undefined;
            return;
        }
        if (typeof v === 'string')
            v = Utils.parseDate(v);
        const leftPad = (i) => Utils.leftPad(i, 2, '0');
        this.year = v.getFullYear();
        this.month = v.getMonth();
        this.date = v.getDate();
        this.hours = leftPad(v.getHours());
        this.minutes = leftPad(v.getMinutes());
        this.seconds = leftPad(v.getSeconds());
    }
    _setupYears() {
        let years = [];
        const min = Utils.parseDate(this.min), max = Utils.parseDate(this.max);
        for (let i = min.getFullYear(); i <= max.getFullYear(); i++) {
            years.push(i);
        }
        this._years = years;
    }
    onChange(evt) {
        return new Promise((resolve, reject) => {
            //if (CustomEventUtils.isInstanceOf(evt, DatetimeChangeEvent)) {
            //    const date = (<DatetimeChangeEvent>evt).detail.date;
            //    resolve(this.value = date); // keep same type (Date or string equivalent)
            //} else {
            //    resolve(this.value = Utils.parseDate(this.value));
            //}
            resolve(this.value = this._computeValue());
        });
    }
    _buildupDates(evt) {
        if (evt)
            evt.stopPropagation();
        const v = this, options = { weekday: 'short', day: 'numeric' }, isDate = (k) => {
            try {
                let monthvalue = +v.month, parsed = new Date(+v.year, +v.month, k);
                return parsed.getMonth() == monthvalue;
            }
            catch (e) {
                return false;
            }
        };
        var dates = [];
        if (!Utils.isNullOrEmpty(v.year) && !Utils.isNullOrEmpty(v.month)) {
            let day = 1;
            do {
                let date = new Date(+v.year, +v.month, day), label = date.toLocaleString(Utils.lang(this), options);
                dates.push({ value: day, date: date, label: label, disabled: date < this.min || date > this.max });
            } while (isDate(++day));
        }
        this._dates = dates;
        if (!isDate(+this.date))
            this.date = '';
        else
            this._buildup();
    }
    _computeValue() {
        const v = this;
        if (Utils.isNullOrEmpty(v.year)
            || Utils.isNullOrEmpty(v.month)
            || Utils.isNullOrEmpty(v.date)) {
            return null;
        }
        else {
            //
            try {
                let value = new Date(+v.year, +v.month, +v.date);
                value.setHours(+v.hours);
                value.setMinutes(+v.minutes);
                value.setSeconds(+v.seconds);
                value.setMilliseconds(0);
                if (!Number.isNaN(value.valueOf())) {
                    return value;
                }
                else
                    return null;
            }
            catch (e) {
                return null;
            }
        }
    }
    _buildup(evt) {
        if (evt)
            evt.stopPropagation();
        //
        this.dateValue = this._computeValue();
    }
    getViewValue(val) {
        const v = /*this.dateValue ||*/ val;
        if (v) {
            return Utils.core.date(v, this.format || (this.precision != 'day' ? 'full' : 'short'), Utils.lang(this));
        }
        return '';
    }
};
__decorate([
    ViewChild('.' + PCSS + '-datetime-picker-year >       ' + P + '-select')
], PacemDatetimePickerElement.prototype, "_yearel", void 0);
__decorate([
    ViewChild('.' + PCSS + '-datetime-picker-month >      ' + P + '-select')
], PacemDatetimePickerElement.prototype, "_monthel", void 0);
__decorate([
    ViewChild('.' + PCSS + '-datetime-picker-date >       ' + P + '-select')
], PacemDatetimePickerElement.prototype, "_dateel", void 0);
__decorate([
    ViewChild('.' + PCSS + '-datetime-picker-hours >      ' + P + '-select')
], PacemDatetimePickerElement.prototype, "_hourel", void 0);
__decorate([
    ViewChild('.' + PCSS + '-datetime-picker-minutes >    ' + P + '-select')
], PacemDatetimePickerElement.prototype, "_minel", void 0);
__decorate([
    ViewChild('.' + PCSS + '-datetime-picker-seconds >    ' + P + '-select')
], PacemDatetimePickerElement.prototype, "_secel", void 0);
__decorate([
    ViewChild(`div.${PCSS}-datetime-picker-fields`)
], PacemDatetimePickerElement.prototype, "_allFields", void 0);
__decorate([
    Watch({ converter: PropertyConverters.Datetime })
], PacemDatetimePickerElement.prototype, "dateValue", void 0);
__decorate([
    Watch({ converter: PropertyConverters.Datetime })
], PacemDatetimePickerElement.prototype, "min", void 0);
__decorate([
    Watch({ converter: PropertyConverters.Datetime })
], PacemDatetimePickerElement.prototype, "max", void 0);
__decorate([
    Watch({ converter: PropertyConverters.String })
], PacemDatetimePickerElement.prototype, "precision", void 0);
__decorate([
    Watch({ emit: false, converter: JsonOrStringConverter })
], PacemDatetimePickerElement.prototype, "format", void 0);
__decorate([
    Watch()
], PacemDatetimePickerElement.prototype, "_dates", void 0);
__decorate([
    Watch()
], PacemDatetimePickerElement.prototype, "_years", void 0);
__decorate([
    Watch()
], PacemDatetimePickerElement.prototype, "year", void 0);
__decorate([
    Watch()
], PacemDatetimePickerElement.prototype, "month", void 0);
__decorate([
    Watch()
], PacemDatetimePickerElement.prototype, "date", void 0);
__decorate([
    Watch()
], PacemDatetimePickerElement.prototype, "hours", void 0);
__decorate([
    Watch()
], PacemDatetimePickerElement.prototype, "minutes", void 0);
__decorate([
    Watch()
], PacemDatetimePickerElement.prototype, "seconds", void 0);
__decorate([
    Debounce(10)
], PacemDatetimePickerElement.prototype, "_buildup", null);
PacemDatetimePickerElement = __decorate([
    CustomElement({
        tagName: P + '-datetime-picker', shadow: Defaults.USE_SHADOW_ROOT,
        template: `<div class="${PCSS}-datetime-picker">
    <div class="${PCSS}-datetime-picker-fields ${PCSS}-viewfinder">

    <div class="${PCSS}-datetime-picker-year">
    <${P}-select value="{{ :host.year, twoway }}" placeholder="..." datasource="{{ :host._years }}">
    </${P}-select></div>

    <div class="${PCSS}-datetime-picker-month">
    <${P}-select value="{{ :host.month, twoway }}" placeholder="..." value-property="value" text-property="label" datasource="{{ :host._months }}">
    </${P}-select></div>

    <div class="${PCSS}-datetime-picker-date">
    <${P}-select value="{{ :host.date, twoway }}" placeholder="..." value-property="value" text-property="label" datasource="{{ :host._dates }}">
    </${P}-select></div>

    <${P}-panel class="${PCSS}-datetime-picker-hours" hide="{{ :host.precision === 'day' }}">
    <${P}-select value="{{ :host.hours, twoway }}" datasource="{{ :host._a24 }}">
    </${P}-select></${P}-panel>

    <${P}-panel class="${PCSS}-datetime-picker-minutes" hide="{{ :host.precision === 'day' }}">
    <${P}-select value="{{ :host.minutes, twoway }}" datasource="{{ :host._a60 }}">
    </${P}-select></${P}-panel>

    <${P}-panel class="${PCSS}-datetime-picker-seconds" hide="{{ :host.precision !== 'second' }}">
    <${P}-select value="{{ :host.seconds, twoway }}" datasource="{{ :host._a60 }}">
    </${P}-select></${P}-panel>

    </div>
    <${P}-panel class="${PCSS}-datetime-picker-preview" hide="{{ Pacem.Utils.isNullOrEmpty(:host.dateValue) || :host.precision === 'day' || :host.readonly }}">
        <dl>
            <dt>local:</dt><dd><${P}-text text="{{ :host.viewValue }}"></${P}-text></dd>
            <dt>iso:</dt><dd><${P}-text text="{{ (:host.dateValue && :host.dateValue.toISOString()) || '' }}"></${P}-text></dd>
        </dl>
    </${P}-panel>
    <${P}-span class="${PCSS}-readonly" css-class="{{ { 'date': :host.precision === 'day', 'datetime': :host.precision !== 'day' } }}" content="{{ :host.viewValue }}" hide="{{ !:host.readonly }}"></${P}-span>
</div>`
    })
], PacemDatetimePickerElement);
export { PacemDatetimePickerElement };
